import { ToastContainer, Slide } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import Footer from "../../../../components/Footer/Footer";
import { useCartPage } from "../hooks/useCartPage";
import CartItem from "../components/CartItem";
import CartSummary from "../components/CartSummary";
import CartEmpty from "../components/CartEmpty";
import "../styles/CartPage.css";
import CartHeader from "../../../../components/Navbars/CartHeader";
import CartFooter from "../../../../components/Footer/CartFooter";

const CartPage = () => {
  const { items, mrpTotal, discountTotal, total, loading, token, breadcrumbPaths } = useCartPage();
  if (!token) {
    return (
      <p style={{ padding: "2rem", textAlign: "center" }}>
        Please login to view your cart.
      </p>
    );
  }

  return (
    <>
    <CartHeader/>

    <div className="bg-cartcolor"> 
      <ToastContainer
        position="top-right"
        autoClose={3000}
        limit={1}
        hideProgressBar
        transition={Slide}
        newestOnTop
        style={{ zIndex: 9999999 }}
      />

      {/* <Breadcrumbs paths={breadcrumbPaths} /> */}
{/* 
      <div className="root-title-chk p0023">
        <span className="title_chk" style={{ fontSize:"17px", fontFamily:"Helvetica Neue"}}>
          <i className="bi bi-cart2" style={{ fontSize:"20px"}}></i> My Cart
          <span className="wishlist-header-count-cart" style={{ fontSize:"18px", bottom:"0", paddingLeft:"5px"}}>
            ({loading ? <Skeleton width={20} /> : items.length})
          </span>
        </span>
      </div> */}

      {/* <div className="cart_mlb">
        <span className="txt_mlb_my">
          My Cart
          <span className="wishlist-header-count-cart" style={{ fontSize: "12px" }}>
            ({loading ? <Skeleton width={20} /> : items.length})
          </span>
        </span>
      </div> */}

      <div className="cart-container containerbox">
     
        <div className="cart-left">
          {/* Skeleton Loader */}
          {loading &&
            Array(3)
              .fill()
              .map((_, i) => (
                <div key={i} style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
                  <Skeleton height={90} width={90} />
                  <div style={{ flex: 1 }}>
                    <Skeleton height={20} width="70%" />
                    <Skeleton height={15} width="40%" style={{ marginTop: 10 }} />
                    <Skeleton height={15} width="30%" style={{ marginTop: 10 }} />
                  </div>
                </div>
              ))}

          {!loading && items.length === 0 && <CartEmpty />}

          {!loading &&
            items.length > 0 &&
            items.map((item) => <CartItem key={item.id} item={item} />)}
        </div>


        {!loading && items.length > 0 && (
          <CartSummary mrpTotal={mrpTotal} discountTotal={discountTotal} total={total} items={items} />
        )}
      </div>

      </div>
      {/* <Footer /> */}
      <CartFooter/>

    </>
  );
};
export default CartPage;